/** @jsx jsx */
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import { Modal, Icon, Row, Col } from "antd";
import { jsx } from "@emotion/core";

import { FormInput } from "../../components/formHelpers";
import { ModalInputTagsStyles } from "../../components/formHelpers/FormHelperStyles";
import Button from "../../components/button";

import { routes } from "../../Routes";

import useEligibilityDetails from "../../hooks/eligibility/useEligibilityDetails";
import useLoanStatus from "../../hooks/auth/useLoanStatus";

import { CurrentBankAccountData } from "../../services/eligibilityService/EligibilityService.type";

import {
  CurrentAccountDetailsValidationSchema as validationSchema,
  CurrentAccountDetailsConstants as CONSTANTS
} from "./CurrentBankAccountDetailsConstants";

import {
  currentBankAccountDetailsStyles,
  currentBankAccountDetailsModalStyles
} from "./CurrentBankAccountDetailsStyle";

const CurrentBankAccountDetails: React.FC = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const {
    saveEligibilityDetails,
    eligibilityState: { loading, eligibilityDetails }
  } = useEligibilityDetails();
  const { disableAccountDetails } = useLoanStatus();

  const onSubmit = (data: CurrentBankAccountData) => {
    saveEligibilityDetails({
      data: {
        bankAccount: data
      },
      onSuccess: () => setOpen(true)
    });
  };

  const handleOk = () => history.push(routes.eligibility.kyc);

  const eligibilityLoanAmount =
    eligibilityDetails?.eligibilityAmountDetails.eligibilityAmount;

  const initialState: CurrentBankAccountData = {
    ...eligibilityDetails?.bankAccount!
  };

  const renderModal = (
    <Modal
      visible={open}
      title={CONSTANTS.modal.title}
      closable={false}
      footer={null}
      centered
      css={[ModalInputTagsStyles, currentBankAccountDetailsModalStyles]}
    >
      <Row>
        <Col span={12} offset={6} className="check-icon">
          <Icon type="check-circle"></Icon>
        </Col>
        <Col span={24} className="modal-content pt-4">
          {CONSTANTS.modal.content}
        </Col>
        <Col span={24} className="modal-content pt-4">
          <Button
            type="primary"
            containerDivClassName="justify-content-around"
            onClick={handleOk}
          >
            {CONSTANTS.buttons.ok}
          </Button>
        </Col>
      </Row>
    </Modal>
  );

  return (
    <div css={currentBankAccountDetailsStyles}>
      <h2 className="loan-acceptance pb-3">
        {CONSTANTS.feedback.loanAcceptance}
        <span>
          {CONSTANTS.feedback.eligibilityAmount(eligibilityLoanAmount || 0)}
        </span>
      </h2>
      <h1 className="title pb-3">{CONSTANTS.feedback.accountVerification}</h1>
      {eligibilityDetails && (
        <Formik
          initialValues={initialState}
          onSubmit={onSubmit}
          validateOnChange
          validateOnBlur
          validationSchema={validationSchema}
        >
          {() => (
            <Form>
              <FormInput
                name="accountNumber"
                label={CONSTANTS.labels.accountNumber}
                placeholder={CONSTANTS.placeholders.accountNumber}
                className="input-field py-3"
                disabled={disableAccountDetails}
                mandatory
              />
              <FormInput
                name="ifscCode"
                label={CONSTANTS.labels.ifscCode}
                placeholder={CONSTANTS.placeholders.ifscCode}
                className="input-field py-3 "
                disabled={disableAccountDetails}
                mandatory
              />
              <FormInput
                name="bankName"
                label={CONSTANTS.labels.bankName}
                placeholder={CONSTANTS.placeholders.bankName}
                className="input-field py-3"
                disabled={disableAccountDetails}
                mandatory
              />
              {!disableAccountDetails && (
                <Button
                  htmlType="submit"
                  type="primary"
                  containerDivClassName="justify-content-md-end mt-3"
                  loading={loading}
                  disabled={loading}
                >
                  {CONSTANTS.buttons.submit}
                </Button>
              )}
            </Form>
          )}
        </Formik>
      )}
      {renderModal}
    </div>
  );
};

export default CurrentBankAccountDetails;
